import { render } from "./Sorting.vue?vue&type=template&id=05696131&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"

import "./Sorting.vue?vue&type=style&index=0&id=05696131&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05696131"

export default script